export const MIN_COMMENT_LENGTH = 8;
